import { useState, useEffect } from 'react';

export const useGeoLocation = () => {
  const [locationInfo, setLocationInfo] = useState(null);
  const [locationError, setLocationError] = useState(null);

  useEffect(() => {
    const options = {
      enableHighAccuracy: true,
      timeout: 10000,
      maximumAge: 0,
    };

    navigator.geolocation.getCurrentPosition(
      ({ coords }) => setLocationInfo(coords),
      (err) => setLocationError(err.message),
      options
    );
  }, []);

  return { locationInfo, locationError };
};